import React from "react";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";

import StyledTableCell from "../../../styles/tableCell";

const TableHeadProductInSite = ({ headCells }) => {
  return (
    <TableHead>
      <TableRow
        style={{
          borderBottom: "0.5px solid gray",
        }}
      >
        {headCells.map((headCell) => (
          <StyledTableCell
            key={headCell.id}
            align="center"
            padding={headCell.disablePadding ? "none" : "default"}
          >
            {headCell.label}
          </StyledTableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};

export default TableHeadProductInSite;
